export enum backspaceKeypressEnum {
  Heading = 'heading',
  Blockquote = 'blockquote',
  Code_Block = 'code_block',
}
